import { render, staticRenderFns } from "./phoneverify.vue?vue&type=template&id=13547143&scoped=true&"
import script from "./phoneverify.vue?vue&type=script&lang=js&"
export * from "./phoneverify.vue?vue&type=script&lang=js&"
import style0 from "./phoneverify.vue?vue&type=style&index=0&id=13547143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13547143",
  null
  
)

export default component.exports